import React from 'react';
import { Database, ArrowRight, Settings as SettingsIcon, ShieldCheck } from 'lucide-react';
import { NavLink } from 'react-router-dom';

const EmptyState: React.FC = () => {
  return (
    <div className="h-full flex flex-col items-center justify-center p-12 text-center animate-in fade-in duration-700">
      <div className="w-24 h-24 bg-slate-900 rounded-[2rem] flex items-center justify-center mb-8 shadow-2xl rotate-3 relative overflow-hidden group">
        <Database size={44} className="text-blue-400 relative z-10 group-hover:scale-110 transition-transform duration-500" />
        <div className="absolute inset-0 bg-gradient-to-tr from-slate-800 to-transparent opacity-50"></div>
      </div>

      <h2 className="text-4xl font-black text-slate-900 mb-4 max-w-lg tracking-tight">
        Awaiting Data Connection
      </h2>

      <p className="text-slate-500 mb-10 max-w-md leading-relaxed font-medium">
        Connect a data source to begin site monitoring and content analysis.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full max-w-4xl text-left mb-12">
        <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm hover:border-blue-400 transition-all">
          <div className="flex items-center gap-2 text-slate-800 font-black mb-3 text-xs uppercase tracking-widest">
            <span className="w-6 h-6 bg-slate-800 text-white rounded-full flex items-center justify-center text-[10px]">1</span>
            Select Source
          </div>
          <p className="text-[11px] text-slate-500 leading-relaxed italic">Use the sidebar dropdown to create a new workspace for your site.</p>
        </div>

        <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm hover:border-blue-400 transition-all">
          <div className="flex items-center gap-2 text-slate-800 font-black mb-3 text-xs uppercase tracking-widest">
            <span className="w-6 h-6 bg-slate-800 text-white rounded-full flex items-center justify-center text-[10px]">2</span>
            Add Sitemaps
          </div>
          <p className="text-[11px] text-slate-500 leading-relaxed italic">Head to <NavLink to="/settings" className="font-bold underline">Settings</NavLink> to add your Yoast sitemap URLs and configure connections.</p>
        </div>

        <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm hover:border-blue-400 transition-all">
          <div className="flex items-center gap-2 text-slate-800 font-black mb-3 text-xs uppercase tracking-widest">
            <span className="w-6 h-6 bg-slate-800 text-white rounded-full flex items-center justify-center text-[10px]">3</span>
            Monitor
          </div>
          <p className="text-[11px] text-slate-500 leading-relaxed italic">Once configured, use Site Monitor to audit your pages and track SEO issues.</p>
        </div>
      </div>

      <div className="flex flex-col items-center gap-4">
        <div className="flex items-center gap-3 px-6 py-3 bg-slate-100 rounded-full text-xs font-black text-slate-700 uppercase tracking-[0.2em] shadow-inner">
          <ArrowRight size={18} className="animate-bounce-x" /> Select a Data Environment to Begin
        </div>
        <NavLink to="/settings" className="text-[10px] font-bold text-slate-400 flex items-center gap-1 hover:text-slate-700 transition-colors">
          <ShieldCheck size={12} /> Setup Guide
        </NavLink>
      </div>

      <style>{`
        @keyframes bounce-x {
          0%, 100% { transform: translateX(0); }
          50% { transform: translateX(5px); }
        }
        .animate-bounce-x {
          animation: bounce-x 1s infinite;
        }
      `}</style>
    </div>
  );
};

export default EmptyState;
